import * as Yup from 'yup';

/* eslint-disable no-useless-escape */
export const InsuranceValidateSchema = (screenText: object = {}) => {
  return Yup.object().shape({
    MEMBER_NUMBER: Yup.string()
      .max(20, screenText.field_1_err_1)
      .required(screenText.field_1_err_2),
    GROUP_NUMBER: Yup.string()
      .max(20, screenText.field_2_err_1)
      .optional(),
    Q_Patient_relationship_to_subscriber: Yup.string().required(screenText.field_3_err_1),
    SUBSCRIBER_FIRST_NAME_ON_CARD: Yup.string()
      .max(16, screenText.field_4_err_1)
      .matches(/^[a-zA-Z-]*$/, screenText.invalid_char_err)
      .required(screenText.field_4_err_2),
    SUBSCRIBER_MIDDLE_NAME_ON_CARD: Yup.string()
      .max(16, screenText.field_5_err_1)
      .matches(/^[a-zA-Z-]*$/, screenText.invalid_char_err)
      .optional(),
    SUBSCRIBER_LAST_NAME_ON_CARD: Yup.string()
      .max(26, screenText.field_6_err_1)
      .matches(/^[a-zA-Z-]*$/, screenText.invalid_char_err)
      .required(screenText.field_6_err_2)
  });
};

export const RELATIONSHIP_TYPE = [
  { label: 'Self', value: 'Self' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Stepchild', value: 'Stepchild' },
  { label: 'Grandchild', value: 'Grandchild' },
  { label: 'Life Partner', value: 'Life Partner' },
  { label: 'Overage Dependent', value: 'Overage Dependent' },
  { label: 'Other', value: 'Other' }
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export interface RelationshipOptionsType {
  label: string;
  value: string;
}

export interface InsuranceInformationData {
  MEMBER_NUMBER: string;
  GROUP_NUMBER: string;
  Q_Patient_relationship_to_subscriber: string;
  SUBSCRIBER_FIRST_NAME_ON_CARD: string;
  SUBSCRIBER_MIDDLE_NAME_ON_CARD: string;
  SUBSCRIBER_LAST_NAME_ON_CARD: string;
}
